/* TPW "How to share your gift list" modal (2026-10-18). Phones/portrait: 1080x2340 file full screen; desktop/landscape: 1920x1080 file in a large 16:9 player. GTM: dataLayer gift_howto_play. */
(function(){
  if(window.TPWHowto)return;
  var modal,box,video,closeBtn,lastFocus,where='gifts',fmt='portrait',fired=false;
  var PORTRAIT='(max-width:600px), (orientation:portrait)';
  function dl(o){try{(window.dataLayer=window.dataLayer||[]).push(o);}catch(e){}}
  function build(){
    modal=document.createElement('div');modal.className='tpw-howto-modal';modal.hidden=true;
    modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','How to share your gift list');
    modal.innerHTML='<div class="tpw-howto-modal__box"><button type="button" class="tpw-howto-modal__x" aria-label="Close video">&times;</button><video class="tpw-howto-modal__v" playsinline webkit-playsinline muted autoplay controls preload="none" disablepictureinpicture></video></div>';
    document.body.appendChild(modal);
    box=modal.firstChild;closeBtn=box.querySelector('button');video=box.querySelector('video');
    closeBtn.addEventListener('click',close);
    modal.addEventListener('click',function(e){if(!box.contains(e.target))close();});
    video.addEventListener('play',function(){if(fired)return;fired=true;dl({event:'gift_howto_play',gift_howto_location:where,gift_howto_format:fmt});});
    document.addEventListener('keydown',function(e){if(modal.hidden)return;
      if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();close();}
      else if(e.key==='Tab'){var f=[closeBtn,video];var i=f.indexOf(document.activeElement);e.preventDefault();f[(i+(e.shiftKey?f.length-1:1))%f.length].focus();}});
  }
  function open(btn){
    if(!modal)build();
    where=btn.getAttribute('data-tpw-howto')||'gifts';fired=false;lastFocus=btn;
    var land=!!btn.getAttribute('data-src-land')&&!(window.matchMedia&&matchMedia(PORTRAIT).matches);fmt=land?'landscape':'portrait';
    var src=btn.getAttribute(land?'data-src-land':'data-src'),poster=btn.getAttribute(land?'data-poster-land':'data-poster')||'';
    modal.classList.toggle('tpw-howto-modal--land',land);
    if(video.getAttribute('src')!==src){video.poster=poster;video.src=src;}
    modal.hidden=false;document.documentElement.classList.add('tpw-howto-lock');
    requestAnimationFrame(function(){modal.classList.add('is-open');});
    video.muted=true;try{video.currentTime=0;}catch(e){}
    var p=video.play();if(p&&p.catch)p.catch(function(){});
    closeBtn.focus({preventScroll:true});
  }
  function close(){
    if(!modal||modal.hidden)return;
    try{video.pause();}catch(e){}
    modal.classList.remove('is-open');modal.hidden=true;document.documentElement.classList.remove('tpw-howto-lock');
    if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-tpw-howto]');if(!b)return;e.preventDefault();open(b);});
  window.TPWHowto={open:function(){var b=document.querySelector('[data-tpw-howto]');if(b)open(b);},close:close,isOpen:function(){return !!modal&&!modal.hidden;}};
})();
